/**
 * User guides — the three role manuals, the family-connection guide and the
 * packages guide, each opened in the browser or downloaded, for every
 * signed-in person regardless of role (the panel's roles are permission
 * sets, not the guides' audiences, so nothing is
 * highlighted). The guides are Persian; only the controls follow the locale.
 */

import { useIntl } from 'react-intl';
import a from '../access/access.module.css';
import { Button } from '@/ui/kit';
import { MANUALS } from './manuals';

export function ManualsPage() {
  const intl = useIntl();
  const t = (id: string, v?: Record<string, string | number>) =>
    intl.formatMessage({ id }, v) as string;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, maxInlineSize: 860 }}>
      <div>
        <h1 className={a.pageTitle}>{t('help.title')}</h1>
        <p className={a.pageSub}>{t('help.sub')}</p>
      </div>
      <ul
        className={a.cardsRow}
        style={{ listStyle: 'none', margin: 0, padding: 0 }}
        aria-label={t('help.title')}
      >
        {MANUALS.map((m) => (
          <li key={m.id} className={a.chooserCard} dir="rtl">
            <span className={a.chooserName}>{m.title}</span>
            <span style={{ fontSize: 12.5, color: 'var(--zc-muted)' }}>
              {t('help.audience', { who: m.audience })}
            </span>
            <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.7, color: 'var(--zc-ink-2)' }}>
              {m.description}
            </p>
            <span style={{ fontSize: 12, color: 'var(--zc-muted)' }}>
              {t('help.version', { version: m.version, date: m.date })}
            </span>
            <span style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBlockStart: 4 }}>
              {/* Same-origin PDF: the browser shows it in a new tab, or saves it under the author's name. */}
              <a href={m.href} target="_blank" rel="noopener">
                <Button variant="primary">{t('help.view')}</Button>
              </a>
              <a href={m.href} download={m.downloadName}>
                <Button variant="quiet">{t('help.download')}</Button>
              </a>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
